<template>
  <b-card
    :title="workshop.name"
    :img-src=workshop.pictureUrl
    img-alt="Image"
    img-top
    tag="article"
    class="h-100 border-0 shadow workshop-card"
  >
    <b-card-text class="small text-secondary">
      {{ workshop.description }}
    </b-card-text>

    <b-card-text class="font-weight-bold">
      {{ $d($dayjs(workshop.datetime), 'long') }}
    </b-card-text>

    <b-card-text>
      <b-row>
        <b-col class="py-3 border-right">
          <b-icon icon="clock-history"></b-icon>
            <template v-if="workshop.isEntireDay">
                Toute la journée
            </template>
            <template v-else>
                {{ formatDuration(workshop.duration) }}
            </template>
        </b-col>
        <b-col class="py-3 ">
          <div v-if="workshop.price">
            <b-icon icon="cash"></b-icon>
            {{ workshop.price / 100 }} €
          </div>
          <div v-else>
            {{ $t('workshops.free') }}
          </div>
        </b-col>
      </b-row>
    </b-card-text>

    <template v-if="workshop.seatsLeftBeforeFrontWarning !== null && (workshop.seats-workshop.participantsCount) <= workshop.seatsLeftBeforeFrontWarning && (workshop.seats-workshop.participantsCount) > 0">
      <b-row align-v="center mt-3">
        <b-col>
            <b-card-text class="text-danger text-uppercase">
              {{ $t('workshops.lastSeats') }}
            </b-card-text>
        </b-col>
      </b-row>
    </template>

    <template #footer>
        <b-row align-v="center" v-if="withRegister">
          <b-col v-if="workshop.participantsCount < workshop.seats">
            <b-card-text v-if="true === workshop.showTotalSeats && false === workshop.showTotalAvailableSeats">
              {{ $tc('workshops.seats', workshop.seats) }}
            </b-card-text>

            <b-card-text v-if="true === workshop.showTotalSeats && true === workshop.showTotalAvailableSeats">
              {{ workshop.participantsCount }} / {{ workshop.seats }}<br>
            </b-card-text>

            <b-card-text v-if="false === workshop.showTotalSeats && true === workshop.showTotalAvailableSeats">
              {{ $tc('workshops.freeSeats', workshop.seats-workshop.participantsCount) }}
            </b-card-text>
          </b-col>
          <b-col v-else>
            <b-card-text>
              {{ $tc('workshops.seats', workshop.seats-workshop.participantsCount) }}
            </b-card-text>
          </b-col>

          <b-col v-if="workshop.participantsCount < workshop.seats"
            :cols="(false === workshop.showTotalSeats && false === workshop.showTotalAvailableSeats) || false === withRegister ? 12 : 8">
            <b-button @click="registerToWorkshop(workshop)"
              variant="primary" block
              :disabled="registrationLoading">
              {{ $t('workshops.actions.register') }}
              <b-icon icon="three-dots" animation="cylon"
                v-if="registrationLoading"></b-icon>
            </b-button>
          </b-col>
        </b-row>

        <b-row align-v="center" v-if="withCancel">
          <b-col :cols="12">
            <b-button @click="cancelWorkshopRegistration(workshop)"
              variant="danger" block
              :disabled="cancelationLoading">
              {{ $t('workshops.actions.cancel') }}
              <b-icon icon="three-dots" animation="cylon"
                v-if="cancelationLoading"></b-icon>
            </b-button>
          </b-col>
        </b-row>
    </template>
  </b-card>
</template>
<script>
import { userEventBus } from '../../events/bus'

import ApiService from '../../services/api'

export default {
  props: {
    workshop: { type: Object },
    withRegister: { type: Boolean, default: true },
    withCancel: { type: Boolean, default: false },
  },

  data() {
    return {
      registrationLoading: false,
      cancelationLoading: false,
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.user
    }
  },

  methods: {
    formatDuration(minutes) {
        if (minutes < 60) {
            return minutes + " min";
        }

        var hours = Math.floor(minutes / 60);
        var remainingMinutes = minutes % 60;
        var duration = hours + "h";

        if (remainingMinutes > 0) {
            duration += "" + remainingMinutes;
        }

        return duration;
    },
    cancelWorkshopRegistration(workshop) {
      if (!this.currentUser) {
        this.$bvModal.show('participantFormModal')

        userEventBus.$off('user.logged').$on('user.logged', () => {
          this.registerToWorkshop(workshop)
        })

        return
      }

      this.cancelationLoading = true

      this.$swal.fire({
        title: false,
        text: this.$i18n.t('workshops.actions.cancelConfirmation'),
        icon: 'danger',
        showCancelButton: true,
        confirmButtonText: this.$i18n.t('common.yes'),
        cancelButtonText: this.$i18n.t('common.no'),
      })
        .then(result => {
          if (false === result.isConfirmed) {
            return this.cancelationLoading = false;
          }

          ApiService.unregisterToWorkshop(workshop.uuid, {
            customerId: this.$store.state.user.id,
            customerOCT: this.$store.state.user.one_click_login_token,
          })
            .then(() => {
              this.$parent.currentWorkshop = undefined
              this.$store.dispatch('removeUserWorkshop', workshop)
              this.$swal(
                this.$i18n.t('workshops.notifications.unregistered.title'),
                this.$i18n.t('workshops.notifications.unregistered.message')
              )
            })
            .catch(error => {
              if (error.response && error.response.status && 400 === error.response.status) {
                return this.$swal(
                  this.$i18n.t('workshops.errors.' + error.response.data.message)
                )
              }

              this.$swal(this.$i18n.t('errors.base'))
            })
            .finally(() => this.cancelationLoading = false)
        });
    },

    registerToWorkshop(workshop) {
      this.$parent.currentWorkshop = workshop

      if (!this.currentUser) {
        this.$bvModal.show('participantFormModal')

        userEventBus.$off('user.logged').$on('user.logged', () => {
          this.registerToWorkshop(workshop)
        })

        return
      }

      this.registrationLoading = true

      ApiService.registerToWorkshop(workshop.uuid)
        .then(() => {
          this.$store.dispatch('addUserWorkshop', workshop)
          this.$swal(
            this.$i18n.t('workshops.notifications.registered.title'),
            this.$i18n.t('workshops.notifications.registered.message')
          )
        })
        .catch(error => {
          if (error.response && error.response.status && 400 === error.response.status) {
            return this.$swal(
              this.$i18n.t('workshops.errors.' + error.response.data.message)
            )
          }

          this.$swal(this.$i18n.t('errors.base'))
        })
        .finally(() => this.registrationLoading = false)
    }
  }
}
</script>
